module.exports = __webpack_public_path__ + "img/solution-cokpit02-system-pic.d0108875.png";